// extracted by mini-css-extract-plugin
export var contrastLow = "_9-1";
export var externalLink = "_9-2";
export var externalLinkIcon = "_9-3";
export var link = "_9-0";
export var linkLabel = "_9-4";